/**
 * Navbar component
 * Handles mobile menu toggle and scroll behavior
 */

function initNavbar() {
    const header = document.querySelector('.header');
    const headerWhite = document.querySelector('.header-white');
    const navbar = document.querySelector('.navbar');
    const navbarToggle = document.getElementById('navbarToggle');
    const navbarMenu = document.getElementById('navbarMenu');
    const navbarLinks = document.querySelectorAll('.navbar__link');
    const navbarWhiteLinks = document.querySelectorAll('.navbar-white__link');
    
    console.log('Navbar elements found:', {
        header: !!header,
        headerWhite: !!headerWhite,
        navbar: !!navbar,
        navbarToggle: !!navbarToggle,
        navbarMenu: !!navbarMenu,
        navbarLinks: navbarLinks.length,
        navbarWhiteLinks: navbarWhiteLinks.length
    });
    
    if (!header && !headerWhite) {
        console.warn('Header elements not found');
        return;
    }
    
    // Handle mobile menu toggle (only if elements exist)
    if (navbarToggle && navbarMenu) {
        console.log('Setting up mobile menu toggle');
        navbarToggle.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            const isMenuOpen = navbarMenu.classList.contains('navbar__menu--active');
            console.log('Toggle clicked, current state:', isMenuOpen);
            
            if (isMenuOpen) {
                // Close menu
                console.log('Closing menu');
                navbarMenu.classList.remove('navbar__menu--active');
                navbarToggle.classList.remove('navbar__toggle--active');
                navbarToggle.setAttribute('aria-expanded', 'false');
                document.body.classList.remove('mobile-menu-open');
            } else {
                // Open menu
                console.log('Opening menu');
                navbarMenu.classList.add('navbar__menu--active');
                navbarToggle.classList.add('navbar__toggle--active');
                navbarToggle.setAttribute('aria-expanded', 'true');
                document.body.classList.add('mobile-menu-open');
            }
        });
        
        // Close mobile menu when clicking on a link
        [...navbarLinks, ...navbarWhiteLinks].forEach(link => {
            link.addEventListener('click', () => {
                navbarMenu.classList.remove('navbar__menu--active');
                navbarToggle.classList.remove('navbar__toggle--active');
                navbarToggle.setAttribute('aria-expanded', 'false');
                document.body.classList.remove('mobile-menu-open');
            });
        });
    }
    
    // Handle active navigation links
    function setActiveNavLink() {
        const currentPath = window.location.pathname;
        const currentPage = currentPath.split('/').pop() || 'index.html';
        
        // Handle regular navbar links
        navbarLinks.forEach(link => {
            const linkPath = link.getAttribute('href');
            if (linkPath && (currentPath.includes(linkPath.replace('#', '')) || 
                (currentPage === 'index.html' && linkPath === '#home') ||
                (currentPage === 'features.html' && linkPath === '#features') ||
                (currentPage === 'pricing.html' && linkPath === '#pricing') ||
                (currentPage === 'contact.html' && linkPath === '#contact'))) {
                link.classList.add('active');
            } else {
                link.classList.remove('active');
            }
        });
        
        // Handle white navbar links
        navbarWhiteLinks.forEach(link => {
            const linkPath = link.getAttribute('href');
            if (linkPath) {
                // Remove leading slash for comparison
                const cleanLinkPath = linkPath.replace(/^\//, '');
                const cleanCurrentPage = currentPage;
                
                if (cleanLinkPath === cleanCurrentPage || 
                    (cleanCurrentPage === 'index.html' && cleanLinkPath === 'index.html') ||
                    (cleanCurrentPage === '' && cleanLinkPath === 'index.html')) {
                    link.classList.add('active');
                } else {
                    link.classList.remove('active');
                }
            } else {
                link.classList.remove('active');
            }
        });
    }
    
    // Handle header background on scroll
    let lastScrollTop = 0;
    
    function handleScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        // Add background when scrolled
        if (scrollTop > 50) {
            if (header) {
                header.classList.add('header--scrolled');
            }
            if (headerWhite) {
                headerWhite.classList.add('header-white--scrolled');
            }
        } else {
            if (header) {
                header.classList.remove('header--scrolled');
            }
            if (headerWhite) {
                headerWhite.classList.remove('header-white--scrolled');
            }
        }
        
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }
    
    // Throttle scroll event for performance
    let isScrolling = false;
    
    window.addEventListener('scroll', () => {
        if (!isScrolling) {
            window.requestAnimationFrame(() => {
                handleScroll();
                isScrolling = false;
            });
            isScrolling = true;
        }
    });
    
    // Handle click outside to close mobile menu (only if elements exist)
    if (navbarMenu && navbarToggle) {
        document.addEventListener('click', (event) => {
            const currentNavbar = navbar || document.querySelector('.navbar-white');
            const isClickInsideNav = currentNavbar && currentNavbar.contains(event.target);
            const isMenuOpen = navbarMenu.classList.contains('navbar__menu--active');
            
            if (!isClickInsideNav && isMenuOpen) {
                navbarMenu.classList.remove('navbar__menu--active');
                navbarToggle.classList.remove('navbar__toggle--active');
                navbarToggle.setAttribute('aria-expanded', 'false');
                document.body.classList.remove('mobile-menu-open');
            }
        });
    }
    
    // Initialize active navigation links
    setActiveNavLink();
}

// Expose to global for concatenated builds
window.initNavbar = initNavbar;